import React from "react";
import styled from "@emotion/styled";

const StyledCross = styled.svg`
  color: ${({ theme }) => theme.header};
  filter: drop-shadow(0.125rem 0.125rem 0 ${({ theme }) => theme.body});
`;

const Cross = () => {
  return (
    <StyledCross
      id="svg"
      xmlns="http://www.w3.org/2000/svg"
      width="400"
      height="807.5471698113207"
      viewBox="0, 0, 400,807.5471698113207"
    >
      <g>
        <path
          id="path0"
          d="M143.396 158.491 L 143.396 313.208 71.698 313.208 L 0.000 313.208 0.000 392.453 L 0.000 471.698 71.698 471.698 L 143.396 471.698 143.396 639.623 L 143.396 807.547 203.774 807.547 L 264.151 807.547 264.151 639.623 L 264.151 471.698 330.189 471.698 L 396.226 471.698 396.226 392.453 L 396.226 313.208 330.189 313.208 L 264.151 313.208 264.151 158.491 L 264.151 3.774 203.774 3.774 L 143.396 3.774 143.396 158.491 "
          stroke="none"
          fill="currentColor"
        />
      </g>
    </StyledCross>
  );
};

export default Cross;
